export class DayWiseTempRequest{
    deptCode: string;
	month?: number;
	startDate?: string;
	endDate?: string;
	uid:string;
}
